import React from 'react'
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import AppButton from '../../../components/global/AppButton'

const styles = {
    summary: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', flex: '1 1 200px', minWidth: 0, columnGap: 1 },
    selectAll: { textTransform: 'none', whiteSpace: 'normal', textAlign: 'left' },
}

export default function PriceSelectionActions({ count, allMatching, total, canSelectAll, disabled, onDelete, onClear, onSelectAll }) {
    const hasSelection = count > 0 || allMatching
    return (
        <>
            <Tooltip title='Clear selection'>
                <span>
                    <IconButton aria-label='Clear selection' disabled={disabled || !hasSelection} onClick={onClear}>
                        <ClearIcon fontSize='small' />
                    </IconButton>
                </span>
            </Tooltip>
            <Box sx={styles.summary}>
                <Typography variant='body2' fontWeight={600} color={hasSelection ? 'text.primary' : 'text.disabled'} role='status' aria-live='polite' aria-atomic='true'>
                    {`${count} selected${allMatching ? ' across all matching pages' : ''}`}
                </Typography>
                <Tooltip title={`Delete selected cached prices (${count})`}>
                    <span>
                        <AppButton aria-label='Delete selected' color='error' size='small' startIcon={<DeleteOutlineIcon fontSize='small' />} disabled={disabled || count === 0} onClick={onDelete}>
                            Delete
                        </AppButton>
                    </span>
                </Tooltip>
                {canSelectAll && (
                    <Button size='small' disabled={disabled} onClick={onSelectAll} sx={styles.selectAll}>
                        {`Select all ${total} matching results`}
                    </Button>
                )}
            </Box>
        </>
    )
}
